import { render } from "./ChaTiView.vue?vue&type=template&id=7a3a0aeb&scoped=true&ts=true"
import script from "./ChaTiView.vue?vue&type=script&lang=ts"
export * from "./ChaTiView.vue?vue&type=script&lang=ts"

import "./ChaTiView.vue?vue&type=style&index=0&id=7a3a0aeb&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3a0aeb"]])

export default __exports__